import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'mandates-filter-button-form',
  templateUrl: './filter-button-form.component.html',
  styleUrls: ['./filter-button-form.component.scss'],
})
export class FilterButtonFormComponent implements OnInit, OnDestroy {
  @Input() filter: filterData;
  @Input() form: UntypedFormGroup;
  @Output() selectionChange: EventEmitter<any> = new EventEmitter<any>();

  isOpen: boolean = false;
  searchValue = '';

  private destroy$ = new Subject<void>();

  constructor() {}

  ngOnInit(): void {
    this.form.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        if (!this.form.contains(this.filter.controlName)) {
          this.resetComponent();
        }
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onSearchClick() {
    this.saveSelection({ name: this.searchValue, value: this.searchValue });
  }

  onFilterClick() {
    this.isOpen = !this.isOpen;
  }

  saveSelection(selection?: { name: string; value: any }) {
    this.selectionChange.emit(selection?.value);
  }

  removeSelectedValue() {
    this.saveSelection();
  }

  private resetComponent() {
    this.isOpen = false;
    this.searchValue = '';
  }

  get isValidSearchValue(): boolean {
    return this.searchValue && this.searchValue.length >= 3 ? true : false;
  }

  get selectedValue(): any {
    const value = this.form.get(this.filter.controlName)?.value;
    if (value) {
      return this.filter.isSearchFilter
        ? { name: value, value }
        : this.filter.options.find((option) => option.value === value);
    }
    return null;
  }
}

interface filterData {
  name: string;
  options: { name: string; value: any }[];
  controlName: string;
  isSearchFilter?: boolean;
}
